import { render, staticRenderFns } from "./tambahtaman.vue?vue&type=template&id=16a93c76&"
import script from "./tambahtaman.vue?vue&type=script&lang=js&"
export * from "./tambahtaman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports